<template>
  <div>
    <el-dialog :title="form.id ? '修改': '新增'" :append-to-body="true" :visible.sync="addDialogVisible" class="imgbox" width="30%"
      :before-close="closeDialog" :close-on-click-modal='false'>
      <el-form label-width="80px" ref="ruleForm" :rules="rules" :model="form">

        <el-form-item label="型号名称" prop="vendorModelName">
          <el-input v-model="form.vendorModelName" maxlength="30" placeholder="请输入型号名称"></el-input>
        </el-form-item>

        <el-form-item label="型号Id" prop="vendorModelId">
          <el-input :disabled="form.id" v-model="form.vendorModelId" maxlength="50" placeholder="请输入型号Id"></el-input>
        </el-form-item>

        <el-form-item label="厂商" prop="vendorId">
          <el-select v-model="form.vendorId" placeholder="请选择厂商" style="width: 100%;">
            <el-option v-for="item in vandorOpts" :key="item.vendorId" :label="item.vendorName" :value="item.vendorId">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="型号描述" prop="vendorModelDesc">
          <el-input v-model="form.vendorModelDesc" maxlength="50" placeholder="请输入型号描述"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { vendorList, modelUpdate, modelAdd, modelGet } from '@/api/productControl'
export default {
  props: {
    addDialogVisible: {
      type: Boolean,
      default: false
    },
    modelUpdateId: {
      type: String
    }
  },
  data() {
    return {
      form: {
        vendorId: '',
        vendorName: '',
        vendorDesc: ''
      },
      vandorOpts: [],
      rules: {
        vendorModelName: [
          { required: true, message: '请输入厂商型号名称', trigger: 'change' }
        ],
        vendorModelId: [
          { required: true, message: '请输入厂商型号Id', trigger: 'change' }
        ],
        vendorId: [
          { required: true, message: '请选择厂商Id', trigger: 'change' }
        ],
        vendorModelDesc: [
          { required: false, message: '请输入型号描述', trigger: 'change' }
        ],
      }
    }
  },
  created() {
    this.vendorListHandle();
    if (this.modelUpdateId) {
      this.modelGetHandle()
    }
  },
  methods: {
    vendorListHandle() {
      const params = {}
      vendorList(params).then(res => {
        this.vandorOpts = res.data.data.list
      })
    },
    modelGetHandle() {
      let params = {
        id: this.modelUpdateId
      }
      modelGet(params).then(res => {
        this.form = res.data.data;
      })
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!this.form.id) {
            const params = Object.assign({}, this.form)
            modelAdd(params).then((res) => {
              if (res.data.code === 200 || res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '新增成功'
                })
                this.$emit('closeAddDialog', 1)
              }
            })
          } else {
            const params = Object.assign({}, this.form)
            modelUpdate(params).then((res) => {
              if (res.data.code === 200 || res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '新增成功'
                })
                this.$emit('closeAddDialog', 1)
              }
            })
          }
        }
      })
    },
    closeDialog() {
      this.$emit('closeAddDialog')
    }
  }
}
</script>